import axios from 'axios'

/**
 * 管理者に2要素認証を必須にするかどうかの設定。
 *
 * ## なぜログイン方法の設定と口を分けるのか
 *
 * 同じ表（`t_account_auth_policy`）を触るが、**互いの列を書かない。**
 * サーバ側も口ごとに別のSQLを持っていて、ログイン方法の保存は `mfa_` 列を
 * 触らず、こちらはログイン方法の列を触らない。
 *
 * 本番の `js/` には過去のビルドが全部残っている。**古い画面が開かれたまま
 * 保存を押す経路は実際に在りうる。**口を分ければ、片方の保存がもう片方を
 * 消す事故は構造的に起こせない。
 *
 * ## 送るのは3つだけ
 *
 * 案内開始日・促し開始日・「あとで」の上限は**サーバが導く。**画面から
 * 送らない。DBには4つあるが、意味が逆に読める（上限0は一度も逃げられない
 * のか無制限なのか、促し日が空は促さないのか即座に促すのか）。入力欄を
 * 消して読み違いごと無くしてある。
 *
 * ## 判断はここでしない
 *
 * 「鍵が無いと必須にできない」「必須日は十分先でなければならない」
 * 「外せる人が2人以上いること」は、**すべてサーバが断る。**画面の縛りは
 * 「押す前に気づける」ためのもので、守りではない。画面を通さずに
 * 投げられたら意味が無い。
 */

const origin = process.env.VUE_APP_API_ORIGIN

const responseData = response => response.data

export default {
  get () {
    return axios.get(origin + '/setting/admin-mfa-policy').then(responseData)
  },

  /**
   * @param payload `{ mfaRequiredForAdmin, mfaRequiredForAdminFrom,
   *                   promptLeadDays }`
   */
  update (payload) {
    return axios.put(origin + '/setting/admin-mfa-policy', payload)
      .then(responseData)
  }
}
